import { render, staticRenderFns } from "./SDG.vue?vue&type=template&id=7520f8c9&"
import script from "./SDG.vue?vue&type=script&lang=js&"
export * from "./SDG.vue?vue&type=script&lang=js&"
import style0 from "./SDG.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports